export enum RequestType {
    POST        = 'POST',
    GET         = 'GET',
    DELETE      = 'DELETE',
    PUT         = 'PUT',
    UPLOAD      = 'UPLOAD'
}